import Layout from "@/components/Layout";
import SEO from "@/components/SEO";
import { Eyebrow } from "@/components/Eyebrow";
import { LogIn } from "lucide-react";
import { Link } from "react-router-dom";

export default function LoginPage() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const handleGoogleSignIn = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href =
      "https://auth.emergentagent.com/?redirect=" + encodeURIComponent(redirectUrl);
  };

  return (
    <Layout withFooter={false}>
      <SEO noindex title="Sign in — Beyond Valencia" canonical="/login" />
      <div
        className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-5 sm:px-8 py-16 bg-bone"
        data-testid="login-page"
      >
        <div className="w-full max-w-md border border-stone/40 bg-bone p-10 sm:p-12">
          <Eyebrow>Beyond Valencia · Sign in</Eyebrow>
          <h1 className="font-serif font-medium text-4xl text-ink mt-4 tracking-tight">Welcome.</h1>
          <p className="text-ink-soft text-sm mt-4 leading-relaxed">
            Use the email associated with your purchase. New here?{" "}
            <Link to="/services" className="text-brass hover:text-ivy underline underline-offset-4 decoration-1">
              See the tiers
            </Link>{" "}
            first.
          </p>
          <button
            onClick={handleGoogleSignIn}
            className="w-full mt-8 inline-flex items-center justify-center gap-2 bg-ivy hover:bg-ivy-light text-bone uppercase tracking-[0.18em] text-xs font-semibold py-4 px-6 transition-colors"
            data-testid="google-signin-btn"
          >
            <LogIn className="h-4 w-4" />
            Sign in with Google
          </button>
          <div className="text-xs text-stone mt-6 leading-relaxed">
            You'll be returned to{" "}
            <code className="px-1.5 py-0.5 bg-bone-dim border border-stone/30 text-[11px] font-mono">/dashboard</code> after Google verifies you.
          </div>
        </div>
      </div>
    </Layout>
  );
}
